import { Outlet } from 'react-router-dom';

import usePageTitle from 'lib/hooks/usePageTitle';

const AdminIQueue = () => {
  usePageTitle('AdminIQueue');

  return (
    <div className="flex h-full overflow-hidden bg-neutral-50" data-dd-privacy="allow">
      <div className="flex w-full flex-col">
        <Outlet />
      </div>
    </div>
  );
};

export default AdminIQueue;
